import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { Loader2 } from 'lucide-react';
import PublicNotFound from './PublicNotFound';
import { getPublicForm, submitPublicReview } from '@/api/reviews';
import { ReviewFormView } from '@/components/reviews/ReviewFormView';

/** my.linzametrics.com/leave_review/<uuid> — public, no login. The uuid is the only
 *  handle (no enumerable ids); the backend throttles per IP and per form. */
export default function LeaveReviewPage() {
  const { publicId = '' } = useParams();
  const { data, error, isLoading } = useSWR(
    publicId ? ['public-review-form', publicId] : null,
    async () => (await getPublicForm(publicId)).data,
    { revalidateOnFocus: false, shouldRetryOnError: false },
  );

  useEffect(() => {
    if (data?.branch_name) document.title = data.branch_name;
  }, [data?.branch_name]);

  if (isLoading) {
    return <div className="flex min-h-dvh items-center justify-center"><Loader2 className="size-6 animate-spin text-neutral-400" /></div>;
  }
  if (error || !data) return <PublicNotFound />;
  // html/body держат overflow:hidden ради прокрутки внутри main приложения
  // (globals.css), поэтому публичная страница прокручивается сама — иначе на
  // телефоне низ карточки с кнопкой «Отправить» просто обрезан.
  return (
    <div className="h-dvh overflow-y-auto">
      <ReviewFormView
        identity={data.identity}
        branchName={data.branch_name}
        address={data.address}
        texts={data.texts}
        options={data.options}
        onSubmit={async (payload) => { await submitPublicReview(publicId, payload); }}
        className="min-h-dvh"
      />
    </div>
  );
}
